import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HostDetails } from "./HostDetails";
import { TrialDetails } from "./TrialDetails";
import { SearchDetails } from "./SearchDetails";
import {
  setHostDetails,
  setSearchDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import PageInfo from "shared/Components/pageInfo";
import { globalVariables } from "helper/globalVariables"

export const AddTrial = (props) => {
  const { isEdit, isAdmin = false } = props || {};
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [saveTrialDetails, setSaveTrialDetails] = useState(false);
  const [saveSearchDetails, setSaveSearchDetails] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const id = location?.state?.id;

  useEffect(() => {
    return () => {
      dispatch(setHostDetails(null));
      dispatch(setTrialDetails(null));
      dispatch(setSearchDetails([]));
    };
  }, []);

  const onChangePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <PageInfo
        isToolTip
        title={isEdit ? globalVariables.editTrial : globalVariables.addTrial}
        onClick={isEdit ? () => navigate(-1) : undefined}
      />
      
      {currentPage === 0 && (
        <HostDetails
          onTapNext={() => {
            setSaveTrialDetails(true);
            setSaveSearchDetails(false);
            onChangePage(1);
          }}
        />
      )}

      {currentPage === 1 && (
        <TrialDetails
          onTapPrevious={() => onChangePage(0)}
          saveTrialDetails={saveTrialDetails}
          onTapNext={() => {
            setSaveTrialDetails(false);
            onChangePage(2);
            setSaveSearchDetails(true);
          }}
        />
      )}

      {currentPage === 2 && (
        <SearchDetails
          currentPage={currentPage}
          saveSearchDetails={saveSearchDetails}
          onTapPrevious={() => {
            setSaveSearchDetails(false);
            setSaveTrialDetails(true);
            onChangePage(1);
          }}
          isAdmin={isAdmin}
          id={id}
          isEdit={isEdit}
        />
      )}
    </div>
  )
};
